module.exports = __webpack_public_path__ + "img/bg-landingpage.f31d2e8d.png";